// Art-direction values for how each brittle shell fails, not measurements.
// charge: seconds of held press to first snap, then to the last one.
// count: pieces per burst at the start, then when the shell is nearly gone.
// loose: every Nth shard falls to the floor. travel and spin scale the pop.
// span: seconds the crack front takes to run through one burst (default .10).
export const CRACK_PROFILES = {
  wax: {charge: [.30, .16], count: [9, 14], loose: 4, travel: 1, spin: 1},
  glass: {charge: [.26, .14], count: [10, 14], loose: 3, travel: 1.4, spin: 1.2},
  chocolate: {charge: [.32, .17], count: [18, 24], loose: 3, travel: 1.35, spin: .5, span: .22},
  crust: {charge: [.38, .20], count: [11, 14], loose: 6, travel: .75, spin: 1.5},
  // Candy shells snap in small bursts after quick cracks spread (halloween-shells.js).
  candy: {charge: [.42, .22], count: [4, 7], loose: 1, travel: 1, spin: 1, span: .16},
  // Packed snow crumbles off in soft clumps that mostly drop.
  snow: {charge: [.36, .20], count: [5, 9], loose: 1, travel: .8, spin: 1.3, span: .18},
};
const KIND = {candyberry: 'glass', chocobar: 'chocolate', melonpan: 'crust', treatpumpkin: 'candy', cracklebat: 'candy', snowbunny: 'snow'};
export const crackProfile = kind => CRACK_PROFILES[KIND[kind]] ?? CRACK_PROFILES.wax;
// Toys whose soft core slumps like slime once its shell breaks.
const MELTING = new Set(['waxball']);
export const crackMelts = kind => MELTING.has(kind);
